import React from "react";
import "./Loader.css";

const Loader = ({ show = false, message = "", overlayStyles = {} }) =>
  show ? (
    <>
      <div className="loader-wrapper">
        <span className="message pb-2">{message}</span>
        {/* <i className="loading-icon" /> */}
        <i className="fa fa-spinner fa-spin" />
      </div>
      <div className="loader-modal-container" style={{ ...overlayStyles }} />
    </>
  ) : null;

export default Loader;
